module.exports = __webpack_public_path__ + "img/f1-1.5f51c446.png";